module.exports = __webpack_public_path__ + "f34daa0643010c4b0d6bb2824010a5cc.svg";